import {Zero, Components, Logger, Utils} from 'Zero';
import StoreLocator from 'Vendor/@openmind/storelocator/dist/storelocator.umd.js';
import $ from 'jquery';

const Log = new Logger("WE3_ZStoreLocator");

export default class ZStoreLocator extends Components {


  get Messages() {
    return {
      "StoreLocator:Detail:Clicked": this.onShowDetailStore
    };
  }


  get StoreLocatorState() {
    return {
      InitialSearch : this.data.InitialCountry,
      InitialCountry: this.data.currentCountry,
      Location: {
        Address: "",
        Bounds: null,
        Center: null
      },
      Pins: null,
      Stores: null,

      Map: {
        Bounds: null,
        Center: null
      },

      Filters: document.querySelectorAll('.pb_sl-filter-input:checked'),
    }
  }


  constructor(element) {
    super(element);

    let additionalOptions = {
      ClusterImagePath: $(".sl__map").data('icons-path') + 'icon-store-group',
      ClusterImageExt: "svg"
    };
    let options = $.extend(true, {}, this.data.sl, additionalOptions);
    this.StoreLocator = new StoreLocator( options );
    let storeLocatorState = this.StoreLocatorState;
    Zero.addState( {StoreLocator: storeLocatorState} );
    this.CAST( "StoreLocator:Init", {StoreLocator: this.StoreLocator} );
    this.onChangeLocation();
    this.onChangeBoundingBox();
    this.onChangeFilters();
    // this.setResultsHeight();
    this.UseLocation = null;
    this.CurrentCountry = this.data.currentCountry;

    this.GRAB("StoreLocator:Search:Place", (msg) => {
      let geoloc = msg.place;

      if ( geoloc && geoloc._type === "_fixed_" ) {
        this.UseLocation = {
          lat: geoloc.lat,
          lng: geoloc.lng
        };
      }
      this.CurrentCountry = msg.searchedCountry;
    });

    this.GRAB("StoreLocator:Map:Moved", (msg) => {
      this.CurrentCountry = null;
    })
  }


//  setResultsHeight() {
//    return
//    let xs = $(window).width() < 768;
//    let filterPanel = (xs == true) ? 0 : $('.pb_sl-filters-panel').outerHeight(true);
//    let search = $('.pb_sl-search').outerHeight(true);
//    let uRow = $('.pb_sl-utility-row').outerHeight(true);
//    let resultOffset = search + filterPanel + uRow;
//    $('.pb_sl-stores-list').css({'top': resultOffset });
//  }


  get react() {
    return {

      onChangeLocation: function() {
        Zero.$state.StoreLocator.Location.Address;
        clearTimeout(this.TimerSearch);
        this.TimerSearch = setTimeout(this.updateGeoJson.bind(this), 0);
      },

      onChangeBoundingBox: function() {
        Zero.$state.StoreLocator.Map.Bounds;
        Zero.$state.StoreLocator.Filters;
        clearTimeout(this.TimerSearch);
        this.TimerSearch = setTimeout(this.updateGeoJson.bind(this), 0);
      },

      onChangeFilters: function() {
        Zero.$state.StoreLocator.Filters;
        clearTimeout(this.TimerSearch);
        this.TimerSearch = setTimeout(this.updateGeoJson.bind(this), 0);
      }
    };
  }


  updateGeoJson() {
    let bounds = Zero.$state.StoreLocator.Map.Bounds;
    let storeName = Zero.$state.StoreLocator.Location.Address;
    let center = Zero.$state.StoreLocator.Map.Center;
    let filters = Zero.$state.StoreLocator.Filters;
    let locationCenter = Zero.$state.StoreLocator.Location.Center;


    if ( !bounds &&  !center ) {
      // map is not initialized
      return;
    }

    // pre-filter
    let prefilter = $(".js-prefilter").attr("data-prefilter");
    if (prefilter) {
      if (filters == null) {
        filters = {}
      }
      filters["features"] = prefilter;
      $(".js-prefilter").data("prefilter", "");
    }

    let data = null;

    if(locationCenter) {
      data = Object.assign({}, {name: storeName, filters: filters } );
    } else {
      data = Object.assign({}, bounds, center, {name: storeName, filters: filters } );
    }


    this.refreshGeoJsonViaAjax(data).then( (geojson) => {

      if( locationCenter ) {

        Zero.$state.StoreLocator.Location.Center = null;
        const g_bounds = this.StoreLocator.Map.Map.getBounds();

        for(let item of geojson.features) {
          const point = item.geometry.coordinates;
          g_bounds.extend(new google.maps.LatLng({lat: point[1], lng:point[0]}) );
        }

        Zero.$state.StoreLocator.Location.Bounds = JSON.parse(JSON.stringify(g_bounds) );
        return;
      }

      geojson = this.filterResults(geojson, {bounds, center, name: storeName, filters});
      this.sortResults(geojson, {bounds, center, name: storeName, filters});
      Zero.$state.StoreLocator.Pins = geojson;
      Zero.$state.StoreLocator.Stores = geojson;

      this.CAST("StoreLocator:GeoJson:Loaded", {geojson: geojson});
      $(window).trigger('checkout:stop.mmfg');
    }, () => {

    });
  }


  filterResults(stores, data) {
    if (!stores) {
      stores = {type: 'FeatureCollection', features: []};
    }

    const inEditorial = document.body.classList.contains('t-editorial');
    const inHomepage = document.body.classList.contains('t-homepage');
    // attivo il filtro per posizione geografica solo se non sono in pagina editoriale
    const filterByBounds = !(inEditorial || inHomepage);

    let pins = [];
    let bounds = data.bounds
    const inCart = document.body.classList.contains('t-cart');
    if (bounds) {
      let g_bounds = new google.maps.LatLngBounds({/*sw*/ lat: bounds.south, lng: bounds.west}, {/*ne*/ lat: bounds.north, lng: bounds.east});
      let feats = stores.features || [];
      for (let feat of feats) {
        let g_point = new google.maps.LatLng({lat: feat.geometry.coordinates[1], lng: feat.geometry.coordinates[0]});
        if (filterByBounds && !g_bounds.contains(g_point)) {
          continue;
        }
        if (inCart) {
          pins.push(feat);
        }else{
          if (!feat.properties.storeHidden) {
            pins.push(feat);
          }
        }
      }
    }

    stores.features = pins;
    return stores;
  }

  sortResults(stores, data) {
    if ( stores && stores.features ) {
      for( let i = 0, store; store = stores.features[i]; i++) {
        store.properties._labelindex = `${i + 1}`;
        store.properties._labelcolor = "#FFF";
      }
    }

    return stores
  }

  refreshGeoJsonViaAjax(data) {
    return new Promise( (resolve, reject) => {
      data.listJson = true;
      data.storeCodes = this.data.stores;
      data.withoutRadius = document.body.classList.contains('t-cart');

      data = Object.assign({}, data, data.filters || {});
      delete data.filters;

      if ( ! this.UseLocation ) {
        delete data.lat;
        delete data.lng;
      } else {
        data.lat = this.UseLocation.lat;
        data.lng = this.UseLocation.lng;
      }


      if ( this.data.forceCountry ){

        data.country = this.data.currentCountry.toUpperCase();

      } else if ( this.CurrentCountry ) {
        data.country = this.CurrentCountry.toUpperCase();
      }

      this._pin_req && this._pin_req.abort();

      this._pin_req = Utils.Ajax.get('/store-locator', data, { traditional: true }).then( (geojson) => {
        this._pin_req = null;
        resolve(geojson)

      }, () => {
        this._pin_req = null;
        reject()
      })
    });
  }


  onShowDetailStore(msg) {
    const store_id = msg.store_id;
    let askDetailPage = $.get( `store/${store_id}?ajax=true`, (html) => {

    })
      .done( (html) => {
        let content = $(html);
        this.element.find('#store-details-container').empty().append( content );
      })
      .fail( (html) => {
        Log.info( `AskDetailPage: cannot retrive remote data from store/${store_id}` );
      })
  }

}

export {
  ZStoreLocator
}
